import {
  Route,
  Switch,
  useHistory,
  Link,
  withRouter,
} from "react-router-dom";
import { Layout, Menu, Typography } from "antd";
import Landing from "./components/LandingPage/landing";
import PreRegister from "./components/PreRegistrationPage/preregister";
import Voting from "./components/VotingPage/voting";
import StsiAuth from "./components/ApprovalPage/auth";
import StsiApproval from "./components/ApprovalPage/approval";
import Tabulation from "./components/TabulationPage/tabulation";
import { auth as fbAuth } from "./firebase";

import Megawhite from "./assets/megawhite.png";
import MegawideLogo from "./assets/redassetmegawide.PNG";
import polyred from "./assets/polyred.PNG";

// eslint-disable-next-line no-unused-vars
import { useDispatch, useSelector } from "react-redux";
// eslint-disable-next-line no-unused-vars

import "./App.css";
import "./App.less";
import { actions } from "./redux";

const { Header, Content, Footer } = Layout;
const { Title } = Typography;

function App() {
  const history = useHistory();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);

  const signOut = () => {
    fbAuth.signOut();
    dispatch(actions.signedOut());
    history.push("/");
  };
  return (
    <div className="App">
      <Layout className="layout">
        <Header>
          <div style={{ display: "flex" }}>
            <Menu
              style={{ flex: "1" }}
              theme="dark"
              mode="horizontal"
              defaultSelectedKeys={["1"]}
            >
              <Menu.Item key="1">
                <Link to="/">Home</Link>
              </Menu.Item>
              {auth.type === "Corporate Secretary" ? (
                <>
                  <Menu.Item key="2">
                    <Link to="/tabulation">Tabulation of Votes</Link>
                  </Menu.Item>
                  <Menu.Item key="3">
                    <Link to="/stsi">Registrants</Link>
                  </Menu.Item>
                </>
              ) : auth.type === "Approver" ? (
                <Menu.Item key="2">
                  <Link to="/stsi">Registrants</Link>
                </Menu.Item>
              ) : auth.isLoggedIn ? (
                <Menu.Item key="2">
                  <Link to="/Voting2022ASM">Vote Here</Link>
                </Menu.Item>
              ) : (
                <Menu.Item key="2">
                  <Link to="/PreRegistration2022ASM">Pre-Register</Link>
                </Menu.Item>
              )}
              {auth.isLoggedIn ? (
                <Menu.Item key="4" onClick={() => signOut()}>
                  Logout
                </Menu.Item>
              ) : (
                <Menu.Item key="4">
                  <Link to="/login">Log in</Link>
                </Menu.Item>
              )}
            </Menu>
          </div>
        </Header>
        <Content style={{ padding: "50px 50px 0" }}>
          <div
            className="site-layout-jumbotron"
            style={{
              backgroundImage: `url(${polyred})`,
              backgroundSize: "cover",
            }}
          >
            <img
              className="responsive"
              src={Megawhite}
              width="100%"
              style={{ paddingBottom: "60px" }}
              alt="megawhite"
            />
            <Title style={{ color: "white" }}>
              2022 Special Stockholders' Meeting
            </Title>
            <img
              width="200px"
              src={MegawideLogo}
              style={{
                position: "absolute",
                bottom: 0,
                right: 0,
              }}
              alt="megawide-logo"
            />
          </div>

          <div className="site-layout-content">
            <Switch>
              <Route exact path="/" component={Landing} />
              <Route path="/PreRegistration2022ASM" component={PreRegister} />
              <Route path="/Voting2022ASM" component={Voting} />
              <Route path="/login" component={StsiAuth} />
              <Route path="/stsi" component={StsiApproval} />
              <Route path="/tabulation" component={Tabulation} />
            </Switch>
          </div>
        </Content>
        <Footer style={{ textAlign: "center" }}>
          Special Stockholders' Meeting ©2022 Megawide Construction Corporation
        </Footer>
      </Layout>
    </div>
  );
}

export default withRouter(App);
